import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Going to the dentist is like trying out a new opensource project",
  "description": "",
  "published": "2011-11-08T00:00:00.000Z",
  "redirect_from": ["/blog/going-to-the-dentist-is-like-trying-out-a-new-opensource-project/swizec/2881"],
  "categories": "Crowdsourcing, Dentist, OpenSource, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Roughly six or seven years have passed since I was last at the dentist's and after having been putting off making an appointment for just over a year now I finally decided to man up and go make an appointment today.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/6325384369_10e9b3492f_m5.jpg",
        "alt": "IMG_3265",
        "title": "IMG_3265"
      }}></img></p>
    <p>{`Of course, the last time I was there I was in high school and somebody, probably mum, simply told me when and where to go and that was that. I may even have been on some sort of reoccuring pattern and the dentist told me when to come next time or something. Don't really remember.`}</p>
    <p>{`Since I'm now a bit older this means an appropriate dentist isn't even in the same building anymore. Luckily the new building is across the street.`}</p>
    <p>{`So I go there and immediately have to make a decision. This thing is like a huge repository of stuff ... think of it like github. You are greeted with a big sign essentially saying `}<em parentName="p">{`"Some interesting projects this way. There are some that other way as well. Oh and some are upstairs"`}</em></p>
    <p>{`Picked the Dentist project and walked through a door.`}</p>
    <p>{`The project consisted of roughly two modules. There was a big Waiting Room module, which I think doubles as a homegrown community forum, an RTG module - might be just a single executable. There was also a module looking more like a collection of executables, called Dentists.`}</p>
    <p>{`Naturally there was no documentation. Well, I'm lying, of course there was some documentaiton. A document listed all the executables in this project and there was a document suggesting I should have a running OS before I attempt to use an executable ... something about things being pricey if I don't.`}</p>
    <p>{`You look at these executables and nothing makes sense.`}</p>
    <p>{`Every executable is described only by its name. Other than that the only information was one executable advertising itself as just having moved to a different location, presumably within the same project, and another saying I should not under any circumstances try to execute it first.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/6325383183_2d45304650_m3.jpg",
        "alt": "45",
        "title": "45"
      }}></img></p>
    <p>{`In a sense this was the worst open source project I ever attempted to use. There was no indication of a project owner or anyone I could contact in case I had any questions. The community forum also looked particularly dead ... there was one member online but I think he was idling and probably wouldn't answer my questions even if I asked.`}</p>
    <p>{`There were some more executables around the corner, but nothing that could really explain what's going on here or what the entry point for the project is. Where to start picking it apart and figuring out how to use this thing.`}</p>
    <p>{`Oh and I also found some random piece of documentation that said all executables have a latency of roughly a month or two. Although I'm not certain how this is useful if you can't even run them in the first place ... maybe they run as a server and you have to somehow issue a request?`}</p>
    <p>{`All in all a really baffling and confusing experience. In the end I just left. Think I need to find someone with experience using this project or some sort of tutorial ...`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=4c2d625b-786d-4bb8-a1b7-3344769d30f9",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      